import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { PageBuilderHandler } from './page-builder-handler';
import { PageContentfulHandler } from './page-contentful-handler';
import { PageNotFoundHandler } from './page-notfound-handler';
import { BasePage } from 'src/app/core/interfaces';
import { BuilderPrefetchService, GenericLogger } from '@scalefast/ecommerce-core';

@Injectable({ providedIn: 'root' })
export class PageHandlerService {
  #handler = inject(PageBuilderHandler);
  #builderPrefetchService = inject(BuilderPrefetchService);
  #logger = inject(GenericLogger);

  constructor() {
    this.#handler.setNext(new PageContentfulHandler()).setNext(new PageNotFoundHandler());
    this.#builderPrefetchService
      .prefetchMostPopular()
      .catch((error) => this.#logger.error('PageHandler: Unexpected error prefetching Builder most popular pages', error));
  }

  async getPage(route: ActivatedRouteSnapshot): Promise<BasePage | null> {
    return await this.#handler?.handle(route);
  }
}
